<script setup lang="ts">
import { historyRange, RANGE_OPTIONS } from "../composables/useRange";
</script>

<template>
  <div class="segmented" role="group" aria-label="时间范围">
    <button
      v-for="option in RANGE_OPTIONS"
      :key="option.id"
      type="button"
      :aria-pressed="historyRange === option.id"
      @click="historyRange = option.id"
    >
      {{ option.label }}
    </button>
  </div>
</template>
